'use client'

/**
 * The product page's body, on the client side of the boundary.
 *
 * It takes a SLUG and looks the product up itself. The page used to do the
 * lookup and pass the product object across, and that object holds React
 * elements — `desc` is a `<p>` with links in it, and a product may carry an
 * `element` block. An element whose type is a client component has to survive
 * as a client REFERENCE when it is serialised into the RSC payload, and under
 * Next 16.3 that fails during static export with
 *
 *     Error: Invalid reference.
 *
 * naming neither the product nor the element. Nothing crosses now but a string.
 */
import React from 'react'
import { Box } from '@hanzo/ui'
import { notFound } from 'next/navigation'

import { Footer, Header, Main } from '@luxfi/ui'
import type ProductDetailBlock from '@/blocks/def/product-detail-block'
import ProductDetailBlockComponent from '@/blocks/components/product-detail-block'
import { products } from '@/content'

import siteDef from '@/site-def'

const ProductPageContent: React.FC<{ slug: string }> = ({ slug }) => {
  const product = products[slug as keyof typeof products] as ProductDetailBlock

  if (!product) {
    notFound()
  }

  return (<>
    <Header siteDef={siteDef}/>
    <Main className='md:flex-row md:gap-4'>
      <ProductDetailBlockComponent block={product}/>
    </Main>
    <Box className='border-t'></Box>
    <Footer siteDef={siteDef} className='w-full pt-16 lg:mx-auto ' />
  </>)
}

export default ProductPageContent
